var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgClone = function SvgClone(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Squire_New---2.2",
    transform: "translate(-1383.000000, -834.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1245.000000, 820.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clone",
    transform: "translate(123.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875,0 L3.375,0 C2.75367187,0 2.25,0.503671875 2.25,1.125 L2.25,2.25 L1.125,2.25 C0.503671875,2.25 0,2.75367187 0,3.375 L0,10.875 C0,11.4963281 0.503671875,12 1.125,12 L8.625,12 C9.24632812,12 9.75,11.4963281 9.75,10.875 L9.75,9.75 L10.875,9.75 C11.4963281,9.75 12,9.24632812 12,8.625 L12,1.125 C12,0.503671875 11.4963281,0 10.875,0 Z M8.484375,10.875 L1.265625,10.875 C1.18795996,10.875 1.125,10.81204 1.125,10.734375 L1.125,3.515625 C1.125,3.43795996 1.18795996,3.375 1.265625,3.375 L2.25,3.375 L2.25,8.625 C2.25,9.24632813 2.75367188,9.75 3.375,9.75 L8.625,9.75 L8.625,10.734375 C8.625,10.81204 8.56204004,10.875 8.484375,10.875 Z M10.734375,8.625 L3.515625,8.625 C3.43795996,8.625 3.375,8.56204004 3.375,8.484375 L3.375,1.265625 C3.375,1.18795996 3.43795996,1.125 3.515625,1.125 L10.734375,1.125 C10.81204,1.125 10.875,1.18795996 10.875,1.265625 L10.875,8.484375 C10.875,8.56204004 10.81204,8.625 10.734375,8.625 Z",
    id: "Shape"
  }))))))));
};
export default SvgClone;